import React from "react";
import { Box, Container, Heading, Text, VStack } from "@chakra-ui/layout";

import { ReactComponent as ServerErrorImage } from "assets/server-error.svg";
import { BasicLayout } from "layouts";

const ServerError: React.FC = () => {
  return (
    <BasicLayout showLogo>
      <Container maxW="1080px" minH="100vh" px={[4, 12]} centerContent>
        <VStack spacing={8} width="100%" mt={24}>
          <Box>
            <ServerErrorImage />
          </Box>
          <Heading size="2xl">Whoops! Something went wrong...</Heading>
          <Text>Please try refreshing the page or come back later.</Text>
        </VStack>
      </Container>
    </BasicLayout>
  );
};

export default ServerError;
